import AbstractJourney from '@/models/v1/abstract-journey.model'
import cloneDeep from 'lodash.clonedeep'

export default class RoundJourney extends AbstractJourney {
  static COLLECTION = 1
  static DISTRIBUTION = 2
  static COLLECTION_AND_DISTRIBUTION = 3

  constructor(journey) {
    super(AbstractJourney.ROUND)
    this.journey = journey
  }

  static splitCircuitoRaccoltaDistribuzione = function (journey) {
    /*
    Il circuito di raccolta e distribuzione deve essere ristrutturato
    in un circuito di raccolta e uno di distributione entrambi con la
    metà dei km percorsi
    */
    // eslint-disable-next-line no-unused-vars
    const { origin, destination, distance, num_journeys } = journey

    const journeyRaccolta = cloneDeep(journey)
    const journeyDistribuzione = cloneDeep(journey)

    const halfDistance = Math.round(distance.loaded / 2)

    journeyRaccolta.round_type = 1
    journeyRaccolta.goods[1] = {
      is_empty: true,
      description: '',
      type: '',
      dangerous_type: '',
      aspect: '',
      weight: '',
    }
    journeyRaccolta.distance.loaded = halfDistance

    journeyDistribuzione.origin = destination
    journeyDistribuzione.destination = origin
    journeyDistribuzione.round_type = 2
    journeyDistribuzione.goods[0] = {
      is_empty: true,
      description: '',
      type: '',
      dangerous_type: '',
      aspect: '',
      weight: '',
    }
    journeyDistribuzione.distance.loaded = halfDistance
    return [journeyRaccolta, journeyDistribuzione]
  }

  static splitCircuitoRaccolta = function (journey) {
    const { origin, destination } = journey

    if (origin.id === destination.id) return [journey]

    const journeyLoaded = cloneDeep(journey)
    const journeyEmpty = cloneDeep(journey)

    journeyLoaded.distance.empty = 0
    journeyLoaded.goods[1].is_empty = ''
    journeyLoaded.goods[1].type = ''

    journeyEmpty.origin = destination
    journeyEmpty.destination = origin
    journeyEmpty.is_empty = true
    journeyEmpty.distance.loaded = 0
    journeyEmpty.num_stops = ''
    journeyEmpty.num_stops_prv = ''
    journeyEmpty._type = RoundJourney._ROUND_OR_SHUTTLE_EMPTY

    journeyEmpty.goods[0] = {
      is_empty: true,
      description: '',
      type: '',
      dangerous_type: '',
      aspect: '',
      weight: '',
    }
    journeyEmpty.goods[1] = {
      is_empty: true,
      description: '',
      type: '',
      dangerous_type: '',
      aspect: '',
      weight: '',
    }
    return [journeyLoaded, journeyEmpty]
  }

  static splitCircuitoDistribuzione = function (journey) {
    const { origin, destination } = journey

    if (origin.id === destination.id) return [journey]

    const journeyLoaded = cloneDeep(journey)
    const journeyEmpty = cloneDeep(journey)

    journeyLoaded.distance.empty = 0
    journeyLoaded.goods[0].is_empty = ''
    journeyLoaded.goods[0].type = ''

    journeyEmpty.origin = destination
    journeyEmpty.destination = origin
    journeyEmpty.is_empty = true
    journeyEmpty.distance.loaded = 0
    journeyEmpty.num_stops = ''
    journeyEmpty.num_stops_prv = ''
    journeyEmpty._type = RoundJourney._ROUND_OR_SHUTTLE_EMPTY

    journeyEmpty.goods[0] = {
      is_empty: true,
      description: '',
      type: '',
      dangerous_type: '',
      aspect: '',
      weight: '',
    }
    journeyEmpty.goods[1] = {
      is_empty: true,
      description: '',
      type: '',
      dangerous_type: '',
      aspect: '',
      weight: '',
    }
    return [journeyLoaded, journeyEmpty]
  }
  static restructured(journey) {
    if (journey.round_type === this.COLLECTION) {
      return this.splitCircuitoRaccolta(journey)
    } else if (journey.round_type === this.DISTRIBUTION) {
      return this.splitCircuitoDistribuzione(journey)
    } else if (journey.round_type === this.COLLECTION_AND_DISTRIBUTION) {
      return this.splitCircuitoRaccoltaDistribuzione(journey)
    } else {
      throw `Round journey type ${journey.round_type} not found`
    }
  }

  static getDestination(journey) {
    const { distance, round_type, origin, destination } = journey

    const traveledWithoutCargo = distance.empty > 0
    const isCollectionAndDistribution = round_type === this.COLLECTION_AND_DISTRIBUTION
    const originAndDestinationAreDifferent = origin.id !== destination.id

    if (traveledWithoutCargo || (isCollectionAndDistribution && originAndDestinationAreDifferent)) {
      return origin
    }

    return destination
  }
}
